'use client';

import { useEffect } from 'react';

interface BlogViewLoggerProps {
  blogId: string;
}

export function BlogViewLogger({ blogId }: BlogViewLoggerProps) {
  useEffect(() => {
    const logView = async () => {
      try {
        await fetch(`/api/blog?id=${blogId}`, {
          method: 'PUT',
        });
      } catch (error) {
        // Silently fail - view logging is not critical
        console.error('Failed to log blog view:', error);
      }
    };

    logView();
  }, [blogId]);

  // This component doesn't render anything
  return null;
}
